import { Component } from "react";
import { connect } from "react-redux";
import SuppliersSelect from "../../shared-components/suppliers-select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMagnifyingGlass,
  faRefresh,
} from "@fortawesome/free-solid-svg-icons";
import {
  setInvoiceInitialData,
  setinvoiceIsLoading,
} from "../../redux-state/features/invoiceSlice/invoiceSlice";
import axios from "axios";
import urls from "../../urls";
import { setSelectedSupplier } from "../../redux-state/features/orderState";
class SearchInvoice extends Component {
  constructor() {
    super();
    this.state = {
      searchType: "none", // 'none', 'singleDate', or 'dateRange'
      selectedDate: "", // Single date
      startDate: "", // Start date for range
      endDate: "", // End date for range
      supplierId: "", // Selected supplier ID
      searchResults: [], // Results from the server
      noResults: false,
    };
    this.faculty_id = JSON.parse(localStorage.getItem("user")).faculty_id;
  }

  // Handle single date input change
  handleDateChange = (event) => {
    this.setState({ selectedDate: event.target.value });
  };

  // Handle start date input change for range
  handleStartDateChange = (event) => {
    this.setState({ startDate: event.target.value });
  };

  // Handle end date input change for range
  handleEndDateChange = (event) => {
    this.setState({ endDate: event.target.value });
  };

  // Handle supplier selection change
  handleSupplierChange = (supplierId) => {
    this.setState({ supplierId });
  };

  // Handle radio button change
  handleSearchTypeChange = (event) => {
    this.setState({
      searchType: event.target.value,
      selectedDate: "", // Reset single date
      startDate: "", // Reset start date
      endDate: "", // Reset end date
    });
  };

  // Search method
  search = async () => {
    this.props.onSearch();
    const { searchType, selectedDate, startDate, endDate } = this.state;
    const supplierId = this.props.selectedSupplier?.value;
    this.props.setinvoiceIsLoading(true);
    try {
      const response = await axios.get(urls.searchInvoices, {
        params: {
          faculty_id: this.faculty_id,
          supplierId,
          selectedDate: searchType === "singleDate" ? selectedDate : null,
          startDate: searchType === "dateRange" ? startDate : null,
          endDate: searchType === "dateRange" ? endDate : null,
        },
      });
      const results = response.data;
      if (results.length) {
        this.props.setInvoiceInitialData(results);
        this.setState({ searchResults: response.data, noResults: false });
      } else {
        this.setState({
          noResults: true,
        });
      }
      this.props.setinvoiceIsLoading(false);
    } catch (err) {
      console.error("Error searching invoices:", err);
      alert("An error occurred while searching invoices");
    } finally {
      this.props.setinvoiceIsLoading(false);
    }
  };
  resetSearchConfig = () => {
    this.props.setSelectedSupplier(null);
    this.props.onReload();
    this.setState({
      searchType: "",
      selectedDate: "", // Reset single date
      startDate: "", // Reset start date
      endDate: "", // Reset end date
    });
    this.props.setinvoiceIsLoading(true);

    axios
      .get(urls.getAllInvoices, {
        params: {
          faculty_id: this.faculty_id,
        },
      })
      .then((res) => {
        const { table_data } = res.data;
        const invoices = table_data ? table_data : [];
        this.props.setInvoiceInitialData(invoices);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        this.props.setinvoiceIsLoading(false);
      });
  };
  render() {
    const {
      searchType,
      selectedDate,
      startDate,
      endDate,
      supplierId,
      searchResults,
      noResults,
    } = this.state;

    return (
      <div
        className="p-2 border border-1 mb-3 rounded-3"
        style={{ fontSize: "12px" }}
      >
        <h6 className="p-2 border-bottom">بحث متقدم</h6>

        <div className="d-flex justify-content-between align-items-center mb-2">
          <div style={{ width: "300px" }}>
            <label>يمكن تحديد اسم المورّد لإستخدامة في البحث </label>
            <SuppliersSelect
              canBeDisabled={false}
              onSupplierChange={this.handleSupplierChange}
              selectedSupplierId={supplierId}
            />
          </div>
          {/* Conditionally render the single date input */}
          {searchType === "singleDate" && (
            <div>
              <label htmlFor="invoiceDate" className="form-label">
                تحديد تاريخ الفاتورة
              </label>
              <input
                type="date"
                className="form-control"
                id="invoiceDate"
                value={selectedDate}
                onChange={this.handleDateChange}
                style={{ width: "300px" }}
              />
            </div>
          )}
          {/* Conditionally render the date range inputs */}
          {searchType === "dateRange" && (
            <div className="d-flex gap-2">
              <div>
                <label htmlFor="startDate" className="form-label">
                  تاريخ البداية
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="startDate"
                  value={startDate}
                  onChange={this.handleStartDateChange}
                />
              </div>
              <div>
                <label htmlFor="endDate" className="form-label">
                  تاريخ النهاية
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="endDate"
                  value={endDate}
                  onChange={this.handleEndDateChange}
                />
              </div>
            </div>
          )}
          <button
            className="btn btn-primary"
            style={{ width: "100px", height: "38px" }}
            onClick={this.search}
          >
            <FontAwesomeIcon icon={faMagnifyingGlass} size="lg" />
            <span className="mx-2">بحث</span>
          </button>
        </div>

        <div className="d-flex   align-items-center pt-2  border-top">
          <div className="form-check">
            <input
              className="form-check-input"
              type="radio"
              id="searchBySingleDate"
              name="searchType"
              value="singleDate"
              checked={searchType === "singleDate"}
              onChange={this.handleSearchTypeChange}
            />
            <label className="form-check-label" htmlFor="searchBySingleDate">
              البحث بتاريخ الفاتورة
            </label>
          </div>
          <div className="form-check mx-3">
            <input
              className="form-check-input"
              type="radio"
              id="searchByDateRange"
              name="searchType"
              value="dateRange"
              checked={searchType === "dateRange"}
              onChange={this.handleSearchTypeChange}
            />
            <label className="form-check-label" htmlFor="searchByDateRange">
              البحث حسب مدة زمنية
            </label>
          </div>
          <div class="vertical-rule"></div>
          <button className="btn border-0" onClick={this.resetSearchConfig}>
            <FontAwesomeIcon icon={faRefresh} size="l" />
          </button>
        </div>
        {noResults && (
          <div className="container text-danger border border-1 border-danger p-2 text-center fs-6 rounded-3">
            لا توجد فواتير بهذه الإعدادات
          </div>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = {
  setInvoiceInitialData,
  setinvoiceIsLoading,
  setSelectedSupplier,
};
const mapStateToProps = (state) => ({
  selectedSupplier: state.orderState.selectedSupplier,
});
export default connect(mapStateToProps, mapDispatchToProps)(SearchInvoice);
